import styled from 'styled-components'

import { theme } from 'src/styles'

const { space, colors, fontSizes, lineHeights } = theme

type OrderedListProps = {
  $pl?: 'sm' | 'md'
  $prefix?: string
}

export const ListItem = styled.li`
  margin-bottom: ${space['spacing-xxxs']};
  font-size: ${fontSizes['font-size-body-2']};
  color: ${colors['neutral-text-weak']};
  line-height: ${lineHeights['font-line-height-lg']};
`

export const OrderedList = styled.ol<OrderedListProps>`
  display: flex;
  flex-direction: column;
  padding-left: ${({ $pl }) => space[`spacing-${$pl}`]};
  margin-bottom: ${space['spacing-sm']}!important;
  gap: ${space['spacing-sm']};
  counter-reset: item;

  ${({ $prefix }) => {
    if ($prefix) return `
      padding-left: 0;

      ${ListItem} {
        display: grid;
        grid-template-columns: ${space['spacing-lg']} auto;
        counter-increment: item;

        &:before {
            content: "${$prefix}." counters(item, ".");
            display: table-cell;
        }
      }
    `
  }}
`

export const UnorderedList = styled.ul`
  display: flex;
  flex-direction: column;
  padding-left: ${space['spacing-sm']};
  margin-bottom: ${space['spacing-sm']}!important;
  gap: ${space['spacing-sm']};
  list-style-type: disc;
`